import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPersonnel, StateStatus } from '@guryou/redux';

const useResources = (stateSelector, ids, archivedAsWell = false) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllPersonnel(null, archivedAsWell));
    }
  }, [archivedAsWell, dispatch, status]);

  if (data && ids) {
    const resourceIds = Array.isArray(ids) ? ids : ids.split(',').map(x => +x);
    return { data: data.filter(x => resourceIds.includes(x.id)), status, version };
  }

  return { data: data || [], status, version, entity };
};

export default useResources;
